<router-outlet />
<div class="container-xxl py-5">
  <div class="container">
    <!-- About Us Start -->
    <div class="row g-5 align-items-center">
      <h1 class="mb-4">{{ ABOUT_DATA.about.title[language] }}</h1>
      <div class="bg-light rounded">
        <div class="row g-0">
          <div
            class="col-lg-6 wow fadeIn"
            data-wow-delay="0.1s"
            style="min-height: 400px"
          >
            <div class="position-relative h-100">
              <img
                class="position-absolute w-100 h-100 rounded"
                src="../../../../assets/img/{{ ABOUT_DATA.about.image }}"
                style="object-fit: none"
              />
            </div>
          </div>
          <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <div class="h-100 d-flex flex-column justify-content-center p-5">
              <p class="mb-4">
                {{ ABOUT_DATA.about.content[language] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- About Us End -->
    <br /><br /><br />
    <!-- Vision Start -->
    <div class="row g-5 align-items-center">
      <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4">{{ ABOUT_DATA.vision.title[language] }}</h1>
        <p>
          {{ ABOUT_DATA.vision.content[language] }}
        </p>
      </div>
      <div class="col-lg-6 about-img wow fadeInUp" data-wow-delay="0.5s">
        <div class="row">
          <div class="col-12 text-center">
            <img
              class="img-fluid w-75 rounded-circle bg-light p-3"
              src="assets/img/{{ ABOUT_DATA.vision.image }}"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Vision End -->
    <br /><br /><br />
    <!-- Mission Start -->
    <h1 class="mb-4">{{ ABOUT_DATA.mission.title[language] }}</h1>
    <div class="bg-transparent rounded">
      <div class="row g-0">
        <div
          class="col-lg-6 wow fadeIn"
          data-wow-delay="0.1s"
          style="min-height: 400px"
        >
          <div class="position-relative h-100">
            <img
              class="position-absolute w-100 h-100 rounded"
              src="assets/img/{{ ABOUT_DATA.mission.image }}"
              style="object-fit: cover"
            />
          </div>
        </div>
        <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
          <div class="h-100 d-flex flex-column justify-content-center p-5">
            <p
              class="mb-4"
              [ngStyle]="{ 'text-align': language === 'ar' ? 'right' : 'left' }"
              [innerHtml]="ABOUT_DATA.mission.content[language]"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Mission End -->
    <br /><br /><br />
    <!-- Contact Us Start -->
    <div class="row g-5 align-items-center">
      <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-3">{{ "get_in_touch_title" | translate }}</h1>
        <!-- <p>
          {{ "get_in_touch_text" | translate }}
        </p> -->
      </div>
      <!-- Subscription Letter with Map Start-->
      <div class="bg-light rounded">
        <div class="row g-0">
          <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
            <div class="h-100 d-flex flex-column justify-content-center p-5">
              <form>
                <div class="row g-3">
                  <div class="col-sm-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control border-0"
                        id="name"
                        placeholder="{{ 'your_name' | translate }}"
                        (change)="onContactFormFieldChange('name', $event)"
                      />
                      <label for="name">{{ "your_name" | translate }}</label>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-floating">
                      <input
                        type="email"
                        class="form-control border-0"
                        id="email"
                        placeholder="{{ 'your_email' | translate }}"
                        (change)="onContactFormFieldChange('email', $event)"
                      />
                      <label for="email">{{ "your_email" | translate }}</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control border-0"
                        id="subject"
                        placeholder="{{ 'subject' | translate }}"
                        (change)="onContactFormFieldChange('subject', $event)"
                      />
                      <label for="subject">{{ "subject" | translate }}</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <textarea
                        class="form-control border-0"
                        placeholder="{{ 'message' | translate }}"
                        id="message"
                        style="height: 100px"
                        (change)="onContactFormFieldChange('message', $event)"
                      ></textarea>
                      <label for="message">{{ "message" | translate }}</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <button
                      class="btn btn-primary w-100 py-3"
                      type="submit"
                      [disabled]="!isValidEmail(contactFormFields.email)"
                      (click)="submitContactForm()"
                    >
                      {{ "send" | translate }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            class="col-lg-6 wow fadeIn"
            data-wow-delay="0.5s"
            style="min-height: 400px"
          >
            <div class="position-relative h-100">
              <iframe
                class="position-relative rounded w-100 h-100"
                src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d109170.1961467051!2d29.867615822685064!3d31.232678442315105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x14f5c4ddb8e2f775%3A0x3c175d976b943b5a!2zOCDYtCDYrNin2KjYsSDYp9mE2LrYstin2YTZidiMINiz2KrYp9mG2YTZidiMINmC2LPZhSDYp9mE2LHZhdmE2IwsIEFsZXhhbmRyaWEgR292ZXJub3JhdGUgNTQ1MjAxMQ!3m2!1d31.233566!2d29.952211499999997!5e0!3m2!1sen!2seg!4v1720039457602!5m2!1sen!2seg"
                frameborder="0"
                style="min-height: 400px; border: 0"
                allowfullscreen=""
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <!-- Subscription Letter with Map End-->
      <div class="row g-4 mb-5">
        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <i class="fa fa-map-marker-alt fa-2x text-primary"></i>
          </div>
          <p>{{ ABOUT_DATA.contact.address[language] }}</p>
        </div>
        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <i class="fa fa-envelope-open fa-2x text-primary"></i>
          </div>
          <br />
          <a href="mailto:{{ ABOUT_DATA.contact.mail }}">{{
            ABOUT_DATA.contact.mail
          }}</a>
        </div>
        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.5s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <i class="fa fa-phone-alt fa-2x text-primary"></i>
          </div>
          <p>{{ ABOUT_DATA.contact.phone }}</p>
        </div>
      </div>
      <!-- <div class="row g-4 mb-5 center-content">
        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <a href="{{ ABOUT_DATA.contact.facebook }}">
              <i class="fab fa-facebook-f fa-2x text-primary"></i
            ></a>
          </div>
          <p>{{ ABOUT_DATA.contact.facebook }}</p>
        </div>

        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <a href="{{ ABOUT_DATA.contact.twitter }}"
              ><i class="fab fa-twitter fa-2x text-primary"></i
            ></a>
          </div>
          <p>{{ ABOUT_DATA.contact.twitter }}</p>
        </div>
      </div> -->
      <div class="row g-4 mb-5">
        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <a href="{{ ABOUT_DATA.contact.facebook }}">
              <i class="fab fa-facebook-f fa-2x text-primary"></i
            ></a>
          </div>
          <br />
          <a href="{{ ABOUT_DATA.contact.facebook }}">{{
            ABOUT_DATA.contact.facebook
          }}</a>
        </div>
        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <a href="{{ ABOUT_DATA.contact.youtube }}">
              <i class="fab fa-youtube fa-2x text-primary"></i
            ></a>
          </div>
          <br />
          <a href="{{ ABOUT_DATA.contact.youtube }}">{{
            ABOUT_DATA.contact.youtube
          }}</a>
        </div>

        <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <a href="{{ ABOUT_DATA.contact.instagram }}"
              ><i class="fab fa-instagram fa-2x text-primary"></i
            ></a>
          </div>
          <a href="{{ ABOUT_DATA.contact.instagram }}">{{
            ABOUT_DATA.contact.instagram
          }}</a>
        </div>
        <!-- <div
          class="col-md-6 col-lg-4 text-center wow fadeInUp"
          data-wow-delay="0.5s"
        >
          <div
            class="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            style="width: 75px; height: 75px"
          >
            <a href="{{ ABOUT_DATA.contact.linkedIn }}"
              ><i class="fab fa-linkedin-in fa-2x text-primary"></i
            ></a>
          </div>
          <p>{{ ABOUT_DATA.contact.linkedIn }}</p>
        </div> -->
      </div>
    </div>
    <!-- Contact Us End -->
  </div>
</div>
